import Swiper from 'swiper';

class Slide {

    constructor(container) {
        this.swiperOptions = {
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 20,
            clickable: true,
            breakpoints: {
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                }
            },
            speed: 500,
            autoplay: {
                delay: 4000
            }, pagination: {
                el: `${container} .swiper-pagination`,
                clickable: true,
            },
        };
        this.container = container;
        new Swiper(this.container, this.swiperOptions);
    }

}

class Recensioni {
    constructor(container) {
        this.swiperOptions = {
            slidesPerView: 2,

            spaceBetween: 20,
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                }
            },
            speed: 500,
            autoplay: {
                delay: 4000
            }, pagination: {
                el: `${container} .swiper-pagination`,
                clickable: true,
            },
        };
        this.container = container;
        new Swiper(this.container, this.swiperOptions);
    }
}

class Team {
    constructor(container) {
        this.swiperOptions = {
            slidesPerView: 3,

            spaceBetween: 20,
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                }
            },
            speed: 500,
            autoplay: {
                delay: 4000
            }, pagination: {
                el: `${container} .swiper-pagination`,
                clickable: true,
            },
        };
        this.container = container;
        new Swiper(this.container, this.swiperOptions);
    }
}











document.addEventListener('DOMContentLoaded', () => {
   const slideClient = new Slide('.swiper-offerta');
  const sliderRecensioni = new Recensioni('.swiper-recensioni');
  const sliderTeam  = new Team('.swiper-team');
   console.log('start');

   let buttonOfferta = document.querySelectorAll('.button-offerta-container');
   let containerOfferta = document.querySelectorAll('.box-container__offerta');

   buttonOfferta.forEach((el) => {
       el.addEventListener('click', (item) => {
           buttonOfferta.forEach((el) => {
               el.querySelector('.button-offerta').style.color = 'black';
           });
       let data = el.getAttribute('data-offerta');
       let switchData = el.getAttribute('data-switch');
       document.querySelector('.box-switch').id = switchData;


           containerOfferta.forEach((el) => {
               el.style.display = 'none';
           });
       document.getElementById(data).style.display = 'block';
       el.querySelector('.button-offerta').style.color = 'white';


       });
   })

});


// WEBPACK FOOTER //
// ./main.js